import { render } from "./Funfacts.vue?vue&type=template&id=044df93d"
import script from "./Funfacts.vue?vue&type=script&lang=js"
export * from "./Funfacts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anderson/Developer/Landing-Page/CambiosItalo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__